<template>
  <div>
    <b-row>
      <b-col style="line-height: 2.4">
        <p> <span class="fontMedium">Folio de referencia a ODT: </span> {{detalleInfo.folioReferencia}} </p>
      </b-col>
    </b-row>
    <b-row>
      <b-col style="line-height: 2.4">
        <p> <span class="fontMedium">Colorímetro: </span> {{detalleInfo.colorimetro}} </p>
      </b-col>
    </b-row>
    <b-row>
      <b-col style="line-height: 2.4">
        <p> <span class="fontMedium">Tono final: </span> {{detalleInfo.tono}} </p>
      </b-col>
    </b-row>

    <b-row v-if="listaDocumentos.length > 0">
      <b-col>
        <VisualizadorArchivos
            :listaDocumentos="listaDocumentos" />
      </b-col>
    </b-row>

  </div>
</template>

<script>

import VisualizadorArchivos from "@/views/LaboratorioV2/OrdenTrabajoPaciente/VisualizadorArchivos.vue";

export default {
  name: "DetalleFlujoDigital",
  components: {VisualizadorArchivos},
  props: {
    detalleInfo: Object,
    listaDocumentos: Array,
  },
}
</script>

<style scoped>

</style>
